import React from 'react'

import { useAlertsDataInfo } from "Pages/ReportsAlerts/Alerts/Conditions/@hooks"
import { AppSitesAutocomplete } from "@components"
import { alertsDrawerData } from "Pages/ReportsAlerts/Alerts/Conditions/@signals"


export default function AlertsSites({ ...props }) {

	const { dataInfo, setDataInfo } = useAlertsDataInfo(alertsDrawerData.peek().sites || [])

	return <AppSitesAutocomplete
		value={dataInfo.value}
		onChange={e => setDataInfo(e.target.value, 'sites')}
		{...props}
	/>
}
